import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useMemo } from 'react';
import { useController } from 'react-hook-form';

import { usePartySizeRange } from 'reservations/account/providers/ConfigProvider';
import { AVAILABILITIES_INPUT_SX } from 'reservations/availabilities/constants';
import { getNumberOfGuestsOptions } from 'reservations/availabilities/helpers/getNumberOfGuestsOptions';

const PartySize = () => {
  const { min, max } = usePartySizeRange();
  const {
    field: { onChange, onBlur, name, value, ref }
  } = useController({
    name: 'partySize'
  });

  const options = useMemo(() => getNumberOfGuestsOptions(min, max), [max, min]);

  return (
    <FormControl fullWidth sx={AVAILABILITIES_INPUT_SX}>
      <InputLabel id="reservations-guests">Guests</InputLabel>
      <Select
        labelId="reservations-guests"
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        name={name}
        inputRef={ref}
        label="Guests"
        IconComponent={KeyboardArrowDownIcon}
        startAdornment={
          <InputAdornment position="start">
            <PersonOutlineIcon />
          </InputAdornment>
        }
      >
        {options.map((option, idx) => (
          <MenuItem value={option} key={option}>
            {idx === options.length - 1 ? `${option}+` : option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PartySize;
